import { z } from 'zod';

import { optionalString } from '@/shared/utils/validation';

export const vplcBindingSchema = z.object({
  orchestratorId: optionalString(),
  autonomyVplcId: optionalString(),
  ipAddress: optionalString(),
});
